import React, { useEffect, useRef } from 'react';
import { googleClickCtaEvent } from '../../../utils/analytics';
import { useMenuItemWithContext } from '../menuContext';
import { TNavigationItemMenuField } from './navigationItem/types/navigationItem.types';
import { documentService, windowService } from '../../../utils/window.utils';

const NavigationItemMenuStructure = ({
  triggerContent,
  actionTitle,
  children,
  extraClassName,
  fullWidth = false,
}: TNavigationItemMenuField): JSX.Element => {
  const [isOpen, setOpen] = useMenuItemWithContext();
  const NavTrayRef = useRef<HTMLDivElement | null>(null);

  const handleClick = (): void => {
    setOpen(!isOpen);
  };
  const baseElementClassName = `navigation__menu-item ${extraClassName}`;
  const elementClassName = baseElementClassName + (isOpen ? ' ' + baseElementClassName + '--open' : '');

  useEffect(() => {
    if (!fullWidth) {
      const navTrayDim = NavTrayRef?.current?.getBoundingClientRect();
      NavTrayRef?.current?.classList.remove('navigation__menu-item__tray--right'); // restting to original position before performing below calculation

      if (navTrayDim && isOpen) {
        const isInViewport =
          navTrayDim?.top >= 0 &&
          navTrayDim?.left >= 0 &&
          Math.floor(navTrayDim?.bottom) <= (windowService().innerHeight || documentService().documentElement.clientHeight) &&
          navTrayDim?.right <= (windowService().innerWidth || documentService().documentElement.clientWidth);
        if (!isInViewport) {
          NavTrayRef?.current?.classList.add('navigation__menu-item__tray--right');
        }
      }
    }
  }, [isOpen, NavTrayRef]);

  return (
    <li className={elementClassName}>
      <button
        className="navigation__menu-item__trigger"
        onClick={(): void => {
          handleClick();
          actionTitle && googleClickCtaEvent('Global Nav', actionTitle, actionTitle);
        }}
      >
        {triggerContent}
      </button>
      <div
        ref={NavTrayRef}
        className={`navigation__menu-item__tray${fullWidth ? ' navigation__menu-item__tray--full-width' : ''}`}
        style={{ display: isOpen ? 'block' : 'none' }}
      >
        {isOpen && children}
      </div>
    </li>
  );
};

export default NavigationItemMenuStructure;
